export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const SET_LOADING = "SET_LOADING";
export const SET_USERDETAILS = "SET_USERDETAILS";
export const SET_LANGUAGE = "SET_LANGUAGE";
export const SET_OTP_TIME = "SET_OTP_TIME";
export const SET_EMAIl_VERIFIED = "SET_EMAIl_VERIFIED";
export const SET_DARK_MODE = "SET_DARK_MODE";
export const SET_AVAILABILITY = "SET_AVAILABILITY";
export const SET_SUPPLIERDETAILS = "SET_SUPPLIERDETAILS";
export const SET_2FA_ENABLED = "SET_2FA_ENABLED";
export const SET_2FA_VERIFIED = "SET_2FA_VERIFIED";
export const INCREMENT_SUPPLIER_CREDITS = "INCREMENT_SUPPLIER_CREDITS";
export const SET_SUPPLIER_CREDITS = "SET_SUPPLIER_CREDITS";










